import React, { Component } from 'react';
import styles from './styles.module.scss';
import configData from '../../../constants/config/newYearVideo.json';
import ReactPlayer from 'react-player';
import newyearVideo from "../../../video/newyearvideo/newyear.mp4"
class NewYearVideo extends Component {
	constructor(props) {
		super(props);
		this.state = {};
	}
	
	render() {
		return (
			<div className={styles.box}>
				<img className={styles.img1} src={require('../../../images/newyearvideo/_01.png')} alt="新春贺岁视频手机端" />
				<img className={styles.imgBg} src={require('../../../images/newyearvideo/mobile/bg.jpg')} alt="新春贺岁视频手机端" />
				<ReactPlayer className={styles.reactPlayer} url={newyearVideo} playing controls muted={false}/>
				<div className={styles.remark}>
					<p>{configData.remark1}</p>
					<p>{configData.remark2}</p>
				</div>
			</div>
		);
	}
}

export default NewYearVideo;
